const ar = {
  login: {
    jeema: "جيما",
    login: "تسجيل الدخول",
    forget_password: "هل نسيت كلمة المرور؟",
    email: "البريد الإلكتروني",
    password: "كلمة المرور",
    email_warning: "البريد الإلكتروني مطلوب",
    password_warning: "كلمة المرور مطلوبة",
  },

  toastify: {
    login_success: "تم تسجيل الدخول بنجاح",
    invalid_message: "البريد الإلكتروني أو كلمة المرور غير صحيحة",
  },

  header: {
    dashboard: "لوحة التحكم",
    profile: "الملف الشخصي",
    logout: "تسجيل الخروج",
  },

  profile: {
    settings: "الإعدادات",
    dashboard: "لوحة التحكم",
    personalInformation: "المعلومات الشخصية",
    firstName: "الاسم الأول",
    lastName: "اسم العائلة",
    emailAddress: "عنوان البريد الإلكتروني",
    updatePassword: "تحديث كلمة المرور",
    currentPassword: "كلمة المرور الحالية",
    newPassword: "كلمة المرور الجديدة",
    confirmNewPassword: "تأكيد كلمة المرور الجديدة",
    cancel: "إلغاء",
    save: "حفظ",
  },
  dashboard: {
    dashboard: "لوحة التحكم",
    systemOverview: "نظرة عامة على النظام",
    totalBookings: "إجمالي الحجوزات",
    totalEarnings: "إجمالي الأرباح",
    totalCustomers: "إجمالي العملاء",
    salons: "الصالونات",
    earnings: "الأرباح",
    allPayments: "جميع المدفوعات",
    earningOverTime: "الأرباح مع مرور الوقت",
    thisYear: "هذا العام",
    totalBusiness: "إجمالي الأعمال",
    individual: "فردي",
    commercial: "تجاري",
  },
  salon: {
    salonsList: "قائمة الصالونات",
    salonsListManagement: "إدارة قائمة الصالونات",
    noData: "لا توجد بيانات",
    dashboard: "لوحة التحكم",
    salons: "الصالونات",
    filter: "تصفية حسب الحالة",
    all: "الكل",
    busy: "مشغول",
    offline: "غير متصل",
    blocked: "محظور",
    available: "متاح",
    businessName: "اسم العمل",
    businessType: "نوع العمل",
    individual: "فردي",
    commercial: "تجاري",
    teamSize: "حجم الفريق",
    genderService: "الخدمة حسب الجنس",
    commercialId: "الرقم التجاري",
    phoneNumber: "رقم الهاتف",
    contactAt: "الاتصال عبر",
    status: "الحالة",
    actions: "الإجراءات",
    page: "صفحة",
    of: "من",
    cancel: "إلغاء",
    salon: "الصالون",
    block: "حظر",
    unblock: "إلغاء الحظر",
    warning: "هل أنت متأكد أنك تريد",
  },
  salon_request: {
    salonRequests: "طلبات الصالون",
    salonRequestManagement: "إدارة طلبات الصالون",
    dashboard: "لوحة التحكم",
    salonRequestList: "قائمة طلبات الصالون",
    filter: "تصفية حسب الحالة",
    all: "الكل",
    blocked: "محظور",
    unverfied: "غير مُحقق",
    rejected: "مرفوض",
    noData: "لا توجد بيانات",
    businessName: "اسم العمل",
    businessType: "نوع العمل",
    individual: "فردي",
    commercial: "تجاري",
    genderService: "الخدمة حسب الجنس",
    commercialId: "الرقم التجاري",
    phoneNumber: "رقم الهاتف",
    contactAt: "الاتصال عبر",
    verified: "تم التحقق",
    createdAt: "تاريخ الإنشاء",
    status: "الحالة",
    actions: "الإجراءات",
    rejectDocument: "رفض المستند",
    enterReason: "أدخل السبب",
    documentRejected: "تم رفض المستند",
    verificationPending: "التحقق من المستند قيد الانتظار",
    cancel: "إلغاء",
    salon: "الصالون",
    block: "حظر",
    unblock: "إلغاء الحظر",
    warning: "هل أنت متأكد أنك تريد",
    submitRejection: "إرسال الرفض",
    page: "صفحة",
    of: "من",
  },

  sidebar: {
    jeema: "جيما",
    dashboard: "لوحة التحكم",
    appManagement: "إدارة التطبيق",
    salons: "الصالونات",
    salonRequests: "طلبات الصالون",
    users: "المستخدمون",
    services: "الخدمات",
    serviceList: "قائمة الخدمات",
    bookings: "الحجوزات",
    payments: "المدفوعات",
    customerSupport: "دعم العملاء",
    tickets: "التذاكر",
    queries: "الاستفسارات",
    reports: "التقارير",
    coupons: "كوبونات",
    charges: "الرسوم",
    customersupport: "الدعم والعملاء",
    faqs: "الأسئلة الشائعة",
    weeklyOffers: "العروض الأسبوعية",
    supportOffers: "عروض الدعم",
  },

  salon_verification: {
    documentReview: "مراجعة المستند",
    rejected: "مرفوض",
    pending: "قيد الانتظار",
    registrationNumber: "رقم التسجيل",
    status: "الحالة",
    preview: "معاينة",
    actions: "الإجراءات",
    documentPreview: "معاينة المستند",
    reason: "السبب",
    reject: "رفض",
    accept: "قبول",
  },

  users: {
    users: "المستخدمون",
    userManagement: "إدارة المستخدمين",
    dashboard: "لوحة التحكم",
    userList: "قائمة المستخدمين",
    filter: "تصفية حسب الحالة",
    active: "نشط",
    blocked: "محظور",
    all: "الكل",
    noData: "لا توجد بيانات",
    name: "الاسم",
    gender: "الجنس",
    male: "ذكر",
    female: "أنثى",
    other: "آخر",
    phoneNumber: "رقم الهاتف",
    createdAt: "تاريخ الإنشاء",
    status: "الحالة",
    actions: "الإجراءات",
    page: "صفحة",
    of: "من",
    cancel: "إلغاء",
    user: "مستخدم",
    block: "حظر",
    unblock: "إلغاء الحظر",
    warning: "هل أنت متأكد أنك تريد",
  },

  user_details: {
    userDetails: "تفاصيل المستخدم",
    userDetailsManagement: "إدارة تفاصيل المستخدم",
    dashboard: "لوحة التحكم",
    users: "المستخدمون",
    email: "البريد الإلكتروني",
    phone: "الهاتف",
    gender: "الجنس",
    country: "الدولة",
    totalBookings: "إجمالي الحجوزات",
    totalProfit: "إجمالي الأرباح",
    male: "ذكر",
    female: "أنثى",
    other: "آخر",
    notAvailable: "غير متوفر",
  },

  toaster: {
    salonVerified: "تم التحقق من الصالون بنجاح",
    salonRejected: "تم رفض الصالون بنجاح",
    userBlocked: "تم حظر المستخدم بنجاح",
    userUnblocked: "تم إلغاء حظر المستخدم بنجاح",
    salonBlocked: "تم حظر الصالون بنجاح",
    salonUnblocked: "تم إلغاء حظر الصالون بنجاح",
    errorOccured: "حدث خطأ",
    service_deleted_successfully: "تم حذف الخدمة بنجاح",
    service_added_successfully: "تمت إضافة الخدمة بنجاح",
    service_updated_successfully: "تم تحديث الخدمة بنجاح",
    queryrevertedsuccessfully: "تم الرد على الاستفسار بنجاح",
    enterReportmessage: "أدخل رسالة التقرير",
    reportrevertedsuccessfully: "تم الرد على التقرير بنجاح",
    ticketrevertedsuccessfully: "تم الرد على التذكرة بنجاح",
    faqAddedSuccessfully: "تمت إضافة سؤال شائع بنجاح",
    faqUpdatedSuccessfully: "تم تحديث السؤال الشائع بنجاح",
    faqdeletedSuccessfully: "تم حذف السؤال الشائع بنجاح",
    weeklyOfferAddedSuccessfully: "تمت إضافة العرض الأسبوعي بنجاح",
    weeklyOfferUpdatedSuccessfully: "تم تحديث العرض الأسبوعي بنجاح",
    weeklyOfferdeletedSuccessfully: "تم حذف العرض الأسبوعي بنجاح",
    weeklyofferpublishedsuccessfully: "تم نشر العرض الأسبوعي بنجاح",
    failedtopublishweeklyoffer: "فشل في نشر العرض الأسبوعي",
    coupondeletedSuccessfully: "تم حذف القسيمة بنجاح",
    couponupdatedSuccessfully: "تم تحديث القسيمة بنجاح",
    couponaddedSuccessfully: "تمت إضافة القسيمة بنجاح",
    couponstatusupdatedsuccessfully: "تم تحديث حالة القسيمة بنجاح",
    failedtoupdatecouponstatus: "فشل في تحديث حالة القسيمة",
    configdeletedSuccessfully: "تم حذف الإعداد بنجاح",
    configUpdatedsuccessfully: "تم تحديث الإعداد بنجاح",
    configaddedsuccessfully: "تمت إضافة الإعداد بنجاح",
    configstatusupdatedsuccessfully: "تم تحديث حالة الإعداد بنجاح",
    failedtoupdateconfigstatus: "فشل في تحديث حالة الإعداد",
  },

  salon_info: {
    salons: "الصالونات",
    salonsListManagement: "إدارة قائمة الصالونات",
    salonRequest: "طلبات الصالون",
    salonRequestManagement: "إدارة طلبات الصالون",
    dashboard: "لوحة التحكم",
    salonDetails: "تفاصيل الصالون",
    basicDetails: "التفاصيل الأساسية",
    documentDetails: "تفاصيل المستند",
    salonInfo: "معلومات الصالون",
    businessHours: "ساعات العمل",
    contactDetails: "تفاصيل الاتصال",
    salonImages: "صور الصالون",
    commercialId: "الرقم التجاري",
    registrationNo: "رقم التسجيل",
    registarationVerified: "تم التحقق من التسجيل",
    reason: "السبب",
    teamSize: "حجم الفريق",
    genderService: "الخدمة حسب الجنس",
    businessType: "نوع العمل",
    homeService: "خدمة منزلية",
    salonStatus: "حالة الصالون",
    categories: "الفئات",
    noBusiness: "لا توجد ساعات عمل متاحة.",
    email: "البريد الإلكتروني",
    address: "العنوان",
    zipcode: "الرمز البريدي",
    country: "الدولة",
    phone: "الهاتف",
    staffMembers: "أعضاء الطاقم",
    gender: "الجنس",
    noImage: "لا توجد صور متاحة.",
    noStaff: "لا يوجد طاقم متاح.",
    individual: "فردي",
    commercial: "تجاري",
    available: "متاح",
    notAvailable: "غير متاح",
    closed: "مغلق",
    rejected: "مرفوض",
    no: "لا",
    employee: "معرّف الموظف",
    status: "الحالة",
  },

  staff: {
    phone: "الهاتف",
    bio: "نبذة",
    gender: "الجنس",
    genderService: "الخدمة حسب الجنس",
    specialistIn: "متخصص في",
    homeService: "خدمة منزلية",
    workingDays: "أيام العمل",
    workingHours: "ساعات العمل",
    breakTime: "وقت الاستراحة",
    services: "الخدمات",
    notAvailable: "غير متاح",
    yes: "نعم",
    no: "لا",
    employee: "معرّف الموظف",
    address: "العنوان",
    country: "الدولة",
    status: "الحالة",
  },

  booking: {
    bookings: "الحجوزات",
    bookingManagement: "إدارة قائمة الحجوزات",
    dashboard: "لوحة التحكم",
    bookingList: "قائمة الحجوزات",
    filter: "تصفية حسب الحالة",
    all: "الكل",
    completed: "مكتمل",
    pending: "قيد الانتظار",
    cancelled: "ملغي",
    rescheduled: "معاد جدولته",
    confirmed: "مؤكد",
    noShow: "لم يحضر",
    noData: "لم يتم العثور على بيانات",
    userName: "اسم المستخدم",
    salonName: "اسم الصالون",
    staffName: "اسم الموظف",
    bookingDate: "تاريخ الحجز",
    duration: "المدة",
    timing: "الوقت",
    userPhone: "رقم هاتف المستخدم",
    status: "الحالة",
    actions: "الإجراءات",
    page: "صفحة",
    of: "من",
  },
  booking_details: {
    bookingDetails: "تفاصيل الحجز",
    bookingDetailsManagement: "إدارة تفاصيل الحجز",
    dashboard: "لوحة التحكم",
    bookings: "الحجوزات",
    userDetails: "تفاصيل المستخدم",
    name: "الاسم",
    email: "البريد الإلكتروني",
    phone: "رقم الهاتف",
    gender: "الجنس",
    genderService: "الخدمة حسب الجنس",
    notAvailable: "غير متوفر",
    male: "ذكر",
    female: "أنثى",
    other: "آخر",
    salonDetails: "تفاصيل الصالون",
    commercialId: "الرقم التجاري",
    staffDetails: "تفاصيل الموظف",
    specialistIn: "متخصص في",
    paymentDetails: "تفاصيل الدفع",
    paymentType: "نوع الدفع",
    paymentStatus: "حالة الدفع",
    promoCode: "رمز الخصم",
    discountType: "نوع الخصم",
    totalAmount: "المبلغ الإجمالي",
    date: "التاريخ",
    time: "الوقت",
    duration: "المدة",
    status: "الحالة",
    categories: "الخدمة",
  },

  queries: {
    queriesManagement: "إدارة الاستفسارات",
    dashboard: "لوحة التحكم",
    queries: "الاستفسارات",
    queryList: "قائمة الاستفسارات",
    filterBystatus: "تصفية حسب الحالة",
    all: "الكل",
    pending: "قيد الانتظار",
    resolved: "تم الحل",
    nodata: "لا توجد بيانات",
    name: "الاسم",
    query: "الاستفسار",
    createdBy: "أنشئ بواسطة",
    createdAt: "تاريخ الإنشاء",
    status: "الحالة",
    actions: "الإجراءات",
    page: "صفحة",
    of: "من",
    confirmDelete: "تأكيد الحذف",
    warning: "هل أنت متأكد أنك تريد حذف الاستفسار؟",
    cancel: "إلغاء",
    delete: "حذف",
    queryDetails: "تفاصيل الاستفسار",
    reportedAt: "تم الإبلاغ في",
    reportedBy: "تم الإبلاغ بواسطة",
    description: "الوصف",
    userDetails: "تفاصيل المستخدم",
    email: "البريد الإلكتروني",
    phone: "رقم الهاتف",
    salonDetails: "تفاصيل الصالون",
    close: "إغلاق",
    business: "العمل",
    country: "البلد",
    queryMessage: "رسالة الاستفسار",
    submit: "إرسال",
    enterquerymessage: "أدخل رسالة الاستفسار",
  },
  reports: {
    reports: "التقارير",
    reportManagement: "إدارة التقارير",
    dashboard: "لوحة التحكم",
    reportList: "قائمة التقارير",
    filterBystatus: "تصفية حسب الحالة",
    all: "الكل",
    pending: "قيد الانتظار",
    resolved: "تم الحل",
    nodata: "لا توجد بيانات",
    reporter: "المُبلغ",
    reportedUser: "المستخدم المُبلغ عنه",
    topic: "الموضوع",
    reportedAt: "تاريخ الإبلاغ",
    reportedBy: "تم الإبلاغ بواسطة",
    status: "الحالة",
    actions: "الإجراءات",
    page: "صفحة",
    of: "من",
    confirmDelete: "تأكيد الحذف",
    warning: "هل أنت متأكد أنك تريد حذف التقرير؟",
    cancel: "إلغاء",
    delete: "حذف",
    reportDetails: "تفاصيل التقرير",
    homeService: "الخدمة المنزلية",
    reportTitle: "عنوان التقرير",
    description: "الوصف",
    reporterUser: "المُبلغ (مستخدم)",
    reporterSalon: "المُبلغ (صالون)",
    name: "الاسم",
    email: "البريد الإلكتروني",
    phone: "رقم الهاتف",
    business: "العمل",
    staffInvolved: "الموظفون المشاركون",
    gender: "الجنس",
    servicesInvolved: "الخدمات المشاركة",
    close: "إغلاق",
    reportMessage: "رسالة التقرير",
    submit: "إرسال",
    enterReportmessage: "أدخل رسالة التقرير",
  },
  ticket: {
    tickets: "التذاكر",
    ticketsManagement: "إدارة التذاكر",
    dashboard: "لوحة التحكم",
    ticketList: "قائمة التذاكر",
    filterBystatus: "تصفية حسب الحالة",
    all: "الكل",
    pending: "قيد الانتظار",
    resolved: "تم الحل",
    nodata: "لا توجد بيانات",
    ticketID: "معرف التذكرة",
    name: "الاسم",
    topic: "الموضوع",
    createdBy: "أنشئت بواسطة",
    createdAt: "تاريخ الإنشاء",
    status: "الحالة",
    actions: "الإجراءات",
    page: "صفحة",
    of: "من",
    confirmDelete: "تأكيد الحذف",
    warning: "هل أنت متأكد أنك تريد حذف التذكرة؟",
    cancel: "إلغاء",
    delete: "حذف",
    ticketDetails: "تفاصيل التذكرة",
    reportedAt: "تم الإبلاغ في",
    reportedBy: "تم الإبلاغ بواسطة",
    description: "الوصف",
    userDetails: "تفاصيل المستخدم",
    email: "البريد الإلكتروني",
    phone: "رقم الهاتف",
    salonDetails: "تفاصيل الصالون",
    business: "العمل",
    country: "البلد",
    bookingDetails: "تفاصيل الحجز",
    customerInformation: "معلومات العميل",
    salonInformation: "معلومات الصالون",
    staffMember: "عضو الطاقم",
    bookingDate: "تاريخ الحجز",
    close: "إغلاق",
    submit: "إرسال",
    enterticketmessage: "أدخل رسالة التذكرة",
  },
  faq: {
    fAQs: "الأسئلة الشائعة",
    fAQsManagement: "إدارة الأسئلة الشائعة",
    dashboard: "لوحة التحكم",
    faqsList: "قائمة الأسئلة الشائعة",
    addFAQ: "إضافة سؤال شائع",
    noData: "لا توجد بيانات",
    page: "صفحة",
    of: "من",
    question: "السؤال",
    answer: "الإجابة",
    actions: "الإجراءات",
    confirmDelete: "تأكيد الحذف",
    warning: "هل أنت متأكد أنك تريد حذف الأسئلة الشائعة؟",
    cancel: "إلغاء",
    delete: "حذف",
    addNewFaq: "إضافة سؤال جديد",
    submit: "إرسال",
    updateFaq: "تحديث السؤال الشائع",
    update: "تحديث",
  },
  weekly_offer: {
    weeklyOffers: "العروض الأسبوعية",
    weeklyOffersManagement: "إدارة العروض الأسبوعية",
    dashboard: "لوحة التحكم",
    weeklyOffer: "عرض أسبوعي",
    weeklyOfferList: "قائمة العروض الأسبوعية",
    addWeeklyOffer: "إضافة عرض أسبوعي",
    noData: "لا توجد بيانات",
    offerPic: "صورة العرض",
    title: "العنوان",
    code: "الكود",
    description: "الوصف",
    status: "الحالة",
    actions: "الإجراءات",
    confirmDelete: "تأكيد الحذف",
    warning: "هل أنت متأكد أنك تريد حذف العرض الأسبوعي؟",
    cancel: "إلغاء",
    delete: "حذف",
    offerPicture: "صورة العرض",
    selectacoupon: "اختر قسيمة",
    submit: "إرسال",
    updateWeeklyOffer: "تحديث العرض الأسبوعي",
    update: "تحديث",
    confirmPublishWeeklyOffer: "تأكيد نشر العرض الأسبوعي",
    note: "ملاحظة",
    publish: "نشر",
    notPublished: "لم يتم النشر",
    Oncepublishedtheweeklyofferwillbevisibletousersandcannotbeedited:
      "بمجرد النشر، سيكون العرض الأسبوعي مرئيًا للمستخدمين ولا يمكن تعديله",
  },
  payment: {
    payments: "المدفوعات",
    paymentsManagement: "إدارة المدفوعات",
    dashboard: "لوحة التحكم",
    paymentsList: "قائمة المدفوعات",
    filterByStatus: "تصفية حسب الحالة",
    all: "الكل",
    paid: "مدفوع",
    unpaid: "غير مدفوع",
    noData: "لا توجد بيانات",
    userName: "اسم المستخدم",
    businessName: "اسم النشاط",
    staffName: "اسم الموظف",
    paymentMethod: "طريقة الدفع",
    amount: "المبلغ",
    status: "الحالة",
    createdAt: "تاريخ الإنشاء",
    page: "صفحة",
    of: "من",
  },
  coupons: {
    addCoupon: "إضافة قسيمة",
    dashboard: "لوحة التحكم",
    coupons: "القسائم",
    couponList: "قائمة القسائم",
    filterbyStatus: "تصفية حسب الحالة",
    all: "الكل",
    active: "نشط",
    inactive: "غير نشط",
    expired: "منتهي الصلاحية",
    noData: "لا توجد بيانات",
    code: "كود",
    expiredDate: "تاريخ الانتهاء",
    minimumAmount: "الحد الأدنى للمبلغ",
    discount: "الخصم",
    UsageCountUserLimit: "عدد مرات الاستخدام / حد المستخدم",
    status: "الحالة",
    actions: "الإجراءات",
    page: "صفحة",
    of: "من",
    confirmDelete: "تأكيد الحذف",
    warning: "هل أنت متأكد أنك تريد حذف القسيمة؟",
    cancel: "إلغاء",
    delete: "حذف",
    updateDiscountCode: "تحديث كود الخصم",
    discountCode: "كود الخصم",
    discountType: "نوع الخصم",
    select: "اختر",
    percentage: "نسبة مئوية",
    fixed: "ثابت",
    promoType: "نوع العرض",
    oneTime: "مرة واحدة",
    multipleUse: "استخدام متعدد",
    newUser: "مستخدم جديد",
    daily: "يومي",
    weekly: "أسبوعي",
    validFrom: "صالح من",
    validTo: "صالح حتى",
    discountValue: "قيمة الخصم",
    maxDiscount: "الحد الأقصى للخصم",
    minBillAmount: "الحد الأدنى للفاتورة",
    usageLimit: "حد الاستخدام",
    userLimit: "حد المستخدم",
    addNewDiscountCode: "إضافة كود خصم جديد",
    selectdiscounttype: "اختر نوع الخصم",
    selectpromotype: "اختر نوع العرض",
    confirm_status_change: "تأكيد تغيير الحالة",
    enterdiscountvalue: "أدخل قيمة الخصم",
    entermaxdiscount: "أدخل الحد الأقصى للخصم",
    enterminimumbillamount: "أدخل الحد الأدنى للفاتورة",
    enterusagelimit: "أدخل حد الاستخدام",
    enteruserlimit: "أدخل حد المستخدم",
    adding: "جاري الإضافة...",
    updating: "جارٍ التحديث...",
    updateCoupon: "تحديث القسيمة",
  },
  charges: {
    charges: "الرسوم",
    chargesManagement: "إدارة الرسوم",
    dashboard: "لوحة التحكم",
    configList: "قائمة الإعدادات",
    addConfig: "إضافة إعداد",
    name: "الاسم",
    type: "النوع",
    value: "القيمة",
    description: "الوصف",
    status: "الحالة",
    actions: "الإجراءات",
    page: "صفحة",
    of: "من",
    addNewConfig: "إضافة إعداد جديد",
    configName: "اسم الإعداد",
    platformCharge: "رسوم المنصة",
    vat: "ضريبة القيمة المضافة",
    configType: "نوع الإعداد",
    percentage: "نسبة مئوية",
    fixed: "ثابت",
    configValue: "قيمة الإعداد",
    configDescription: "وصف الإعداد",
    cancel: "إلغاء",
    submit: "إرسال",
    updateConfig: "تحديث الإعداد",
    confirmStatusChange: "تأكيد تغيير الحالة",
    Warning: "تحذير",
    thiswill: "هذا سيقوم بـ",
    deactivate: "تعطيل",
    notice: "ملاحظة",
    activate: "تفعيل",
    yes: "نعم",
    no: "لا",
    enterdescription: "أدخل الوصف",
    active: "نشط",
    inactive: "غير نشط",
    confirmDelete: "تأكيد الحذف",
    update: "تحديث",
    delete: "حذف",
    warning: "هل أنت متأكد أنك تريد حذف الإعداد؟",
    theconfigurationItwilltakeeffectandbeusedbythesystemaccordingly:
      "الإعداد. سيتم تطبيقه واستخدامه من قبل النظام وفقًا لذلك.",
    theconfigurationThesystemwillignorethissettinguntilitreactivated:
      "الإعداد. سيتجاهل النظام هذا الإعداد حتى يتم إعادة تفعيله.",
  },
  category: {
    categoryDetails: "تفاصيل الفئة",
    categoryDetailsManagement: "إدارة تفاصيل الفئة",
    dashboard: "لوحة التحكم",
    categories: "الفئات",
    serviceList: "قائمة الخدمات",
    addService: "إضافة خدمة",
    update: "تحديث",
    delete: "حذف",
    addNewService: "إضافة خدمة جديدة",
    serviceName: "اسم الخدمة",
    serviceDescription: "وصف الخدمة",

    cancel: "إلغاء",
    servicePicture: "صورة الخدمة",
    submit: "إرسال",
    updateService: "تحديث الخدمة",
    description: "الوصف",
    categoriesManagement: "إدارة الفئات",
    categoryList: "قائمة الفئات",
    addCategory: "إضافة فئة",
    categoryPic: "صورة الفئة",
    categoryName: "اسم الفئة",
    actions: "الإجراءات",
    addNewCategory: "إضافة فئة جديدة",
    categoryDescription: "وصف الفئة",
    categoryPicture: "صورة الفئة",
    updateCategory: "تحديث الفئة",
    descriptionmustbeatleastcharacters:
      "يجب أن يحتوي الوصف على 50 حرفًا على الأقل.",
  },

  service: {
    services: "الخدمات",
    serviceManagement: "إدارة قائمة الخدمات",
    dashboard: "لوحة التحكم",
    serviceList: "قائمة الخدمات",
    addService: "إضافة خدمة",
    editService: "تحديث الخدمة",
    addNewService: "إضافة خدمة جديدة",
    warning: "هل أنت متأكد أنك تريد الحذف",
    service: "الخدمة؟",
    confirmDelete: "تأكيد الحذف",
    cancel: "إلغاء",
    submit: "إرسال",
    update: "تحديث",
    delete: "حذف",
    noData: "لا توجد بيانات",
    serviceName: "اسم الخدمة",
    serialNo: "الرقم التسلسلي",
    createdAt: "تاريخ الإنشاء",
    actions: "الإجراءات",
    page: "صفحة",
    of: "من",
  },
  couponStatusModal: {
    confirm_status_change: "تأكيد تغيير الحالة",
    yes: "نعم",
    no: "لا",
    warning: "تحذير",
    inactive_warning:
      "تغيير حالة هذا الكوبون قد يؤثر على توفره للمستخدمين. الرجاء المراجعة بعناية.",
    active_warning: "هل أنت متأكد من تفعيل هذا الكوبون؟",
  },
};

export default ar;
